import React, { useState } from 'react'
import { Button, PlusIcon, MinusIcon, Tooltip, CopyIcon } from '@diversioteam/diversio-ds'
import parser from 'html-react-parser'

import { useCopyToClipboard } from 'hooks/useCopyToClipboard'

import { TemplateAccordionProps } from './templateAccordion.types'
import * as S from './templateAccordion.styles'

export const TemplateAccordion = ({ id, name, title, content }: TemplateAccordionProps) => {
    const [expanded, setExpanded] = useState(false)

    const { isCopied: isTitleCopied, copyToClipboard: copyTitleToClipboard } = useCopyToClipboard()
    const { isCopied: isContentCopied, copyToClipboard: copyContentToClipboard } = useCopyToClipboard()

    const handleAccordionChange = (_: React.ChangeEvent<object>, isExpanded: boolean) => {
        setExpanded(isExpanded)
    }

    return (
        <S.Accordion expanded={expanded} onChange={handleAccordionChange}>
            <S.AccordionSummary
                aria-controls={`${id}-content`}
                id={`${id}-header`}
                expandIcon={expanded ? <MinusIcon type="line" /> : <PlusIcon type="line" />}
            >
                <S.TemplateTitle>{name}</S.TemplateTitle>
            </S.AccordionSummary>

            <S.AccordionDetails>
                <S.TemplateContent isTitle={true}>
                    {title}
                    <Tooltip
                        title="Copied!"
                        variant="light"
                        size="medium"
                        open={isTitleCopied}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                    >
                        <Button
                            color="primaryLight"
                            size="small"
                            onClick={() => copyTitleToClipboard(title)}
                            leftIcon={<CopyIcon type="line" />}
                        >
                            Copy
                        </Button>
                    </Tooltip>
                </S.TemplateContent>

                <S.TemplateContent>
                    {parser(content)}
                    <Tooltip
                        title="Copied!"
                        variant="light"
                        size="medium"
                        open={isContentCopied}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                    >
                        <Button
                            color="primaryLight"
                            size="small"
                            onClick={() => copyContentToClipboard(content)}
                            leftIcon={<CopyIcon type="line" />}
                        >
                            Copy
                        </Button>
                    </Tooltip>
                </S.TemplateContent>
            </S.AccordionDetails>
        </S.Accordion>
    )
}
